const atoms = {
  exchangeStatusAtom: 'EVENT_EXCHANGE_STATUS',
};

const events = {
  exchangeRates: 'EVENT_EXCHANGE_RATES',
};

const eventsReduxMap = { ...atoms, ...events };

export default eventsReduxMap;
